import { merge } from 'lodash'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

type State = {
  menuOpen: boolean
  modalOpen: boolean
  headerHide: boolean
  headerBackground: boolean
  lockScroll: boolean
}

type Actions = {
  // eslint-disable-next-line no-unused-vars
  setLayoutState: (state?: Partial<State>) => void
}

const initialState: State = {
  menuOpen: false,
  modalOpen: false,
  headerBackground: false,
  headerHide: false,
  lockScroll: false
}

const useLayoutStore = create(
  subscribeWithSelector(
    immer<State & Actions>((set) => ({
      ...initialState,
      setLayoutState: (state) => set((prevState) => merge(prevState, state))
    }))
  )
)

export { useLayoutStore }
